export const tabNavigation = (elements) => {
    elements.forEach(button => {
        button.addEventListener("click", (event) => {
            const targetID = event.target.getAttribute("data-tab-target")

            const target = document.getElementById(targetID)

            if (target) {
                event.target.parentElement.querySelector(`.active[data-tab-target]`)?.classList.remove("active");
                event.target.classList.add("active");
                const siblings = target.parentElement.querySelectorAll(".tab-navigation__tab:not([hidden])")
                siblings.forEach(sibling => sibling.hidden = true)
                target.hidden = false;
            }
        })
    })
}
